import { Lock, Sparkles, Wrench, Shirt, Home } from "lucide-react";
import { TEASERS } from "../constants";
import { Reveal } from "./Reveal";

const ICONS = { Sparkles, Wrench, Shirt, Home };

const Future = () => (
    <section
        className="py-16 sm:py-24 lg:py-32"
        style={{ background: "linear-gradient(180deg, #F4F8FF 0%, #FFFFFF 100%)" }}
        data-testid="future-section"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <div className="max-w-3xl">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B5CF5] mb-4">The road ahead</p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="font-display font-medium text-slate-900 text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-[1.1]">
                        This is just <span className="italic text-[#0B5CF5]">the beginning.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                        Once everyday household help runs reliably in our first zone, Sevano will grow into
                        more categories — guided by what Agartala asks for. Nothing here is available yet;
                        consider it a glimpse.
                    </p>
                </Reveal>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {TEASERS.map((t, i) => {
                    const Icon = ICONS[t.icon];
                    return (
                        <Reveal key={t.title} delay={i * 0.1}>
                            <div
                                className="relative h-full rounded-3xl border border-dashed border-[#0B5CF5]/30 bg-white/70 backdrop-blur-sm p-6 sm:p-8 overflow-hidden transition-all duration-300 hover:border-[#0B5CF5]/60 hover:shadow-[0_20px_50px_-20px_rgba(11,92,245,0.25)]"
                                data-testid={`future-teaser-card-${i}`}
                            >
                                <div className="teaser-blur">
                                    <div className="w-12 h-12 rounded-2xl bg-[#F4F8FF] flex items-center justify-center mb-5">
                                        <Icon size={22} className="text-[#0B5CF5]" />
                                    </div>
                                    <h3 className="text-lg font-bold text-slate-900 mb-2 tracking-tight">{t.title}</h3>
                                    <p className="text-sm text-slate-600 leading-relaxed">{t.desc}</p>
                                </div>
                                <div className="absolute top-4 right-4 inline-flex items-center gap-1.5 rounded-full bg-white border border-[#0B5CF5]/25 px-3 py-1 shadow-sm">
                                    <Lock size={11} className="text-[#0B5CF5]" />
                                    <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#0B5CF5]">Coming later</span>
                                </div>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Future;
